import axios from "axios";
import { url, dispatchLoading, dispatchToast, dispatchError, catchHandler, elseHandler } from "../../utils";

const settingUrl = url + "setting";

export const UpdateSetting = (updates) => async (dispatch) => {
  dispatchLoading(dispatch, "setting", true);
  axios
    .put(settingUrl, { updates }, { withCredentials: true })
    .then((result) => {
      if (result?.data?.success) {
        dispatchToast(dispatch, "success", result?.data?.msg);
        dispatchError(dispatch, "setting", undefined);
      } else elseHandler(dispatch, "setting", result?.data);
      dispatchLoading(dispatch, "setting", false);
    })
    .then(() => {
      dispatch(GetSetting());
    })
    .catch(catchHandler(dispatch, "setting"));
};

export const GetSetting = () => async (dispatch) => {
  dispatchLoading(dispatch, "setting", true);
  let noDiskCache = { noDiskCache: 1, timeStamp: `${new Date().getTime()}` };
  axios
    .get(settingUrl, { params: noDiskCache, withCredentials: true })
    .then((result) => {
      if (result?.data?.success) {
        dispatch({ type: "SETTING_FETCH_SUCCESS", payload: result?.data?.data });
        dispatchError(dispatch, "setting", undefined);
      } else elseHandler(dispatch, "setting", result?.data);
      dispatchLoading(dispatch, "setting", false);
    })
    .catch(catchHandler(dispatch, "setting"));
};

export const SocialMediaLoginToggle = (updates) => async (dispatch) => {
  dispatchLoading(dispatch, "setting", true);
  axios
    .put(settingUrl, { updates }, { withCredentials: true })
    .then((result) => {
      if (result?.data?.success) {
        dispatch({ type: "SOCIAL_MEDIA_LOGIN_TOGGLE" });
        dispatchToast(dispatch, "success", result?.data?.msg);
        dispatchError(dispatch, "setting", undefined);
      } else elseHandler(dispatch, "setting", result?.data);
      dispatchLoading(dispatch, "setting", false);
    })
    .then(() => {
      dispatch(GetSetting());
    })
    .catch(catchHandler(dispatch, "setting"));
};
